import { __awaiter, __generator } from "tslib";
import { STORES_FQDN } from '@wix/wixstores-client-core/dist/es/src/constants';
var CustomUrlApi = /** @class */ (function () {
    function CustomUrlApi(buildCustomizedUrl) {
        this.buildCustomizedUrl = buildCustomizedUrl;
        //
    }
    CustomUrlApi.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.buildCustomizedUrl(STORES_FQDN.PRODUCT_PAGE, { slug: 'abc' }, { pathPrefix: 'product-page' })
                        .then(function (url) { return !!(_this.stub = url === null || url === void 0 ? void 0 : url.replace(/abc/g, '{stub}')); })
                        .catch(function () { return false; })];
            });
        });
    };
    CustomUrlApi.prototype.buildProductPageUrl = function (urlSegments) {
        return this.getProductWithStub(urlSegments);
    };
    CustomUrlApi.prototype.getProductWithStub = function (urlSegments) {
        if (!this.stub) {
            throw new Error('init CustomUrlApi wasn`t called');
        }
        return this.stub.replace(/{stub}/g, urlSegments.slug);
    };
    return CustomUrlApi;
}());
export { CustomUrlApi };
//# sourceMappingURL=CustomUrlApi.js.map